export default "__VITE_ASSET__CEv9ow5q__"